
import React, { forwardRef } from 'react';
import { StarIcon } from '@heroicons/react/20/solid';

interface StarsProps {
    value?: number;
    onChange?: (newValue: number) => void;
    totalStars?: number; 
}

const Stars = forwardRef(({ value = 0, onChange, totalStars = 5 }: StarsProps, ref) => {
    const handleClick = (input: number) => {
        if (input === value) {
            input = 0;
        } 
        onChange && onChange(input);
    }
    return (
        <div ref={ref} className="flex">
            <span className="sr-only">{`${value} out of ${totalStars} stars`}</span>
            <div className="flex flex-grow-0 flex-row-reverse gap-x-1 text-neutral">
            {Array.from({ length: totalStars }, (_, index) => (
                <StarIcon
                key={index}
                onClick={() => handleClick(totalStars - index)}
                className={`h-8 w-8 flex-none peer stroke-1 stroke-cta peer-hover:text-cta-hover hover:text-cta-hover ${ (value >= (totalStars - index)) ? ' text-cta' : ''}`}
                aria-hidden="true"
                />
            ))}
            </div>
        </div>
    );
});

export default Stars;
